<template>
  <NuxtLink to="/" class="flex gap-3 m-auto" external>
    <NuxtImg provider="cdnProvider" alt="Thorne logo" src="/images/layout/thorne-logo.svg"
            class="m-auto h-5.5"/>
    <NuxtImg provider="cdnProvider" :alt="`${currentCountry.code} flag`"
            :src="`/images/layout/flags/${currentCountry.code.toLowerCase()}.png`"
            class="w-8 h-8" v-if="showCountryFlag && currentCountry && currentCountry.code !== 'US'"/>
  </NuxtLink>
</template>

<script setup lang="ts">

interface NavLogoProps {
  showCountryFlag?: boolean;
}

const {
  showCountryFlag = false
} = defineProps<NavLogoProps>();


const localeStore = useLocaleStore();
const currentCountry = computed(() => localeStore.locale?.country);

</script>
